import React from 'react';

interface WarningModalProps {
  isOpen: boolean;
  onSignUp: () => void;
  onExit: () => void;
}

const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  onSignUp,
  onExit
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1100] p-4">
      <div className="bg-slate-100 dark:bg-neutral-900 rounded-3xl p-8 max-w-md w-full mx-4 relative border-4 border-lime-500">
        <button
          onClick={onExit}
          className="absolute top-6 right-6 text-ui-text-secondary hover:text-ui-text-primary text-2xl transition-colors"
        >
          ✕
        </button>
        
        <div className="text-center">
          <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <div className="text-white text-2xl font-bold">⚠</div>
          </div>
          
          <h2 className="text-3xl font-bold text-ui-text-primary mb-6">
            WARNING!
          </h2>
          
          <p className="text-ui-text-primary text-lg font-bold mb-2">
            Are you sure you want to exit?
          </p>
          <p className="text-ui-text-primary text-lg font-semibold mb-6">
            You will lose your life altering project!
          </p>
          
          <p className="text-ui-text-secondary mb-2">
            Create your dreams on us.
          </p>
          
          <p className="text-ui-text-secondary mb-1">
            Sign up now and take advantage of
          </p>
          <p className="text-brand-primary text-lg font-bold mb-2">
            750 free credits
          </p>
          <p className="text-ui-text-secondary mb-8">
            No strings attached. Just limitless creation power.
          </p>
          
          <div className="space-y-4">
            <button
              onClick={onSignUp}
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl text-sm font-medium text-black bg-brand-primary hover:bg-brand-primaryDark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary transition-colors"
            >
              Sign Up Now, Create For Free
            </button>
            
            <button
              onClick={() => window.location.href = 'https://kolega.studio/home'}
              className="w-full py-2 px-4 text-sm text-ui-text-secondary hover:text-ui-text-primary transition-colors flex items-center justify-center"
            >
              Exit Anyway
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;